import type { Theme } from '@mui/material/styles';

/**
 * Resolves a color string to a hex value.
 * - Values starting with '#', 'rgb', 'hsl' are returned as-is.
 * - Everything else is treated as a MUI palette reference in dot-notation:
 *     "primary"         → theme.palette.primary.main
 *     "error.dark"      → theme.palette.error.dark
 *     "success.light"   → theme.palette.success.light
 *   If the reference doesn't resolve, the raw value is returned as a fallback.
 */
export function resolveMuiColor(color: string | undefined, theme: Theme): string | undefined {
    if (!color) return undefined;

    // Pass through raw CSS color values
    if (color.startsWith('#') || color.startsWith('rgb') || color.startsWith('hsl')) {
        return color;
    }

    // Treat everything else as a MUI palette dot-path
    const parts = color.split('.');
    const palette = theme.palette as unknown as Record<string, Record<string, string>>;
    const paletteEntry = palette[parts[0]];
    if (paletteEntry) {
        const shade = parts[1] ?? 'main';
        const resolved = paletteEntry[shade];
        if (resolved) return resolved;
    }

    return color;
}
